<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VOOytl/tc-custom/9781429954631.jpg?1718858879374" alt="This image is the cover for the book Half a Crown"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Half a Crown
      </h1>
      <p class="bookDescription body article font2">
        <b>With “understated prose and deft characterizations” a Hugo and Nebula Award–winning author’s imagines post-WWII England as a fascist regime (<i>Publishers Weekly</i>).</b><br/><br/>In 1941 the European war ended in the Farthing Peace, a rapprochement between Britain and Nazi Germany. The balls and banquets of Britain’s upper class never faltered, while British ships ferried “undesirables” across the Channel to board the cattle cars headed east.<br/><br/>Peter Carmichael is commander of the Watch, Britain’s distinctly British secret police. It’s his job to warn the Prime Minister of treason, to arrest plotters, and to discover Jews. The midnight knock of a Watchman is the most dreaded sound in the realm.<br/><br/>Now, in 1960, a global peace conference is convening in London, where Britain, Germany, and Japan will oversee the final partition of the world. Hitler is once again on British soil. So is the long exiled Duke of Windsor—and the rising gangs of “British Power” streetfighters, who consider the Government “soft,” may be the former king’s bid to stage a coup d’état.<br/><br/>Amidst all this, two of the most unlikely persons in the realm will join forces to oppose the fascists: a debutante whose greatest worry until now has been where to find the right string of pearls, and the Watch Commander himself.<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jo Walton
      </h2>
      
      <p class="authorDescription body article"><P>JO WALTON is the author of several novels including the World Fantasy Award–winning <I>Tooth and Claw.</I> A native of Wales, she lives in Montreal.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6d312b74